module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4d9232fc24395ff39049820e215c9733.png";